enum ROUTES {
  SIGN_IN = '/signin',
  SIGN_UP = '/signup',
  RESET_PASSWORD = '/reset-password',
  DASHBOARD = '/',
  USERS = '/users',
  PROFILE = '/profile',
  USER = '/user/:id',
  TOKEN_EXPIRED = '/token-expired',
  PAGE_NOT_FOUND = '/404',
  USER_WIZARD = '/setup-wizard',
  TRANSACTIONS = '/transactions',
  TRANSACTION_CREATE = '/transaction/create',
  TRANSACTION_DETAIL = '/transaction/:id',
  APPOINTMENTS = '/appointments',
  ACTIVE_APPOINTMENTS = '/active-appointments',
  HISTORY_APPOINTMENTS = '/overdue-appointments',
  SERVICE_TYPES = '/service-types',
  ACCOUNTINGS = '/accountings',
  ACCOUNTING_DETAIL = '/accounting/:type/:id',
  ACCOUNTING_DETAIL_INVOICE_DETAIL = '/accounting/:type/:id/:invoiceId',
  SYSTEM_LOG = '/system-log',
  COMPANY = '/company',
  COMPANY_LOCATION = '/company-location',
}

export default ROUTES;
